import React from "react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

function NoResultsFound() {
  return (
    <Wrapper>
      <Typography variant="h4">No results found</Typography>
    </Wrapper>
  );
}

export default NoResultsFound;
